import TrackingScript from './tracking-script';

/**
 * Implements the Snapchat pixel
 * @see: https://businesshelp.snapchat.com/en-US/a/pixel-website-install
 */
export default class Hotjar extends TrackingScript {
    async inject() {
        if (!window.language.hotjar_site_id) {
            return;
        }

        if (!(await this.allowedInject())) {
            return;
        }

        if (window.__hotjar_injected) {
            // Already injected
            return;
        }

        // Hotjar Tracking Code
        (function (h, o, t, j, a, r) {
            h.hj =
                h.hj ||
                function () {
                    (h.hj.q = h.hj.q || []).push(arguments);
                };
            h._hjSettings = { hjid: window.language.hotjar_site_id, hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

        window.__hotjar_injected = true;
    }
}
